import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  flex-direction: column;
  justify-content: start;
  margin-bottom: 24px;
  margin: 0 auto 1rem;
  overflow: scroll;
`;

export const Header = styled.header`
    align-items: center;
    display: flex;
    justify-content:space-between;
    margin-bottom: 32px;


    h1 {
        color: ${({ theme }) => theme.colors.gray.shark};
    }

    a{
      border:2px solid  ${({ theme }) => theme.colors.primary.main};
      border-radius: 4px;
      color: ${({ theme }) => theme.colors.primary.main};
      font-weight: bold;
      text-decoration: none;
      padding: 8px 16px;
      transition: all 0.2s ease-in;

      &:hover{
        background: ${({ theme }) => theme.colors.primary.main};
        color: #fff;
      }
    }

`;

export const Table = styled.table`
  border-spacing: 0;
  min-width: 500px;
  display: table;
  min-width: 100%;
`;

export const TableBody = styled.tbody`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray.oslo};
  white-space: nowrap;

  tr {
    :nth-child(odd) {
      background-color: #FFF;
    }
  }

  td {
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray.oslo};
    border-right: 1px solid ${({ theme }) => theme.colors.gray.oslo};
    font-size: 1rem;
    margin: 0;
    padding:  .25rem .75rem;
    white-space: pre-wrap;

    :last-child {
      border-right: 0;
    }

    :first-child {
      min-width: 48px;
      width: 48px;
      max-width: 48px;

      /* a{
        color: transparent;
        text-shadow: 0 0 10px rgba(0,0,0,0.5);
      } */
    }
  }
`;

export const ResultTableData = styled.td`
background: ${({ isSuccess, isWarning }) => (isSuccess ? '#27ae6070'
    : isWarning ? '#FAB00570' : '#eb575770')};
color: ${({ theme, isSuccess, isWarning }) => (isSuccess ? theme.colors.success
    : isWarning ? theme.colors.warning : theme.colors.error)};
font-weight: 600;
border-left: 0.25rem solid ${({ theme, isSuccess, isWarning }) => (isSuccess
    ? theme.colors.success : isWarning ? theme.colors.warning : theme.colors.error)} ;
`;

export const NextReportTableData = styled.td`
background: ${({ isLate }) => (isLate ? '#eb575770' : '#27ae6070'
  )};
color: ${({ theme, isLate }) => (isLate ? theme.colors.error : theme.colors.success)};
font-weight: 600;
border-left: 0.25rem solid ${({ theme, isLate }) => (isLate
    ? theme.colors.error : theme.colors.success)} ;
`;

export const WorkspaceTHeader = styled.th`
  border: none;
  border-top: 2rem solid ${({ theme }) => theme.colors.backgroundColor};
  color: ${({ theme }) => theme.colors.gray.trout};
  display: flex;
  font-size: 1.5rem;
  white-space: nowrap;
  /* color: transparent;
        text-shadow: 0 0 10px rgba(0,0,0,0.5); */

  button {
    margin-left: 16px;
  }
`;

export const THeader = styled.th`
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray.oslo};
  border-right: 1px solid ${({ theme }) => theme.colors.gray.oslo};
  font-size: 1rem;
  margin: 0;
  padding:  0.5rem 0.75rem;
  white-space: nowrap;

  :last-child {
    border-right: 0;
  }

  :first-child {
    min-width: 48px;
    width: 48px;
    max-width: 48px;
  }
`;

export const IconButton = styled.button`
  border: none;
  outline: none;
  background-color: transparent;
  /* don't take the whole line */
  display: inline-block;
  /* transition the background change */
  transition: background-color 0.25s;
  /* height of the icon */
  height: 2em;
  /* width of the icon */
  width: 2em;
  /* space between the icon and the background edge */
  padding: 0.25em;
  /* make it rounded */
  border-radius: 50%;

  :hover {
    background-color: rgba(0, 0, 0, .15);
  }

  .material-symbols-outlined {
    cursor: pointer;
    font-variation-settings:
    'FILL' 0,
    'wght' 600,
    'GRAD' -25,
    'opsz' 40;
    color: red;
  }

  .grey {
    color: grey;
  }
`;

export const Pre = styled.pre`
    background-color: #eeeeee;
    height: 50%;
    font-family: 'Lucida Console',Consolas,Monaco,'Andale Mono','Ubuntu Mono',monospace;
    line-height: 1.5;
    direction: ltr;
    white-space: pre;
    text-align: left;
    word-wrap: normal;
    word-break: normal;
    word-spacing: normal;
    tab-size: 4;
    overflow: auto;
  `;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const MarginTop = styled.div`
  margin-top: 1rem;
`;
